<script>
export const groupId = 'group-' + Math.random().toString(36).substring(2, 15)
</script>

<script setup>
import { frames } from '../../../../utils/frames'
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  item: Array,
})

const gradientElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Bottom' })
    .startInvisible(gradientElement)
    .from(gradientElement, { y: '+=400', duration: frames(13), ease: 'power3.in' })
})

const { onDisappear } = useDisappearable()
onDisappear(async () => await gsapTimeline({ name: 'Bottom Disappear' }).to(gradientElement, { y: '+=400', duration: 1, ease: 'power3.in' })) // should have duration of 0.32
// TODO: This is temporarily set to 1 second, however, it should actually wait for all children to complete their end animation. I believe we currently have no logic for this.

const firstItemComponent = computed(() => props.item[0]) // Ignore other items, only render the first one. Avoids overlapping items.
</script>

<template>
  <div class="w-full h-full">
    <div ref="gradientElement" class="absolute bottom-0 w-full h-[400px] bg-gradient-to-t from-black/40" />
    <component :is="firstItemComponent.component" v-if="firstItemComponent" :key="firstItemComponent.key" :item="firstItemComponent.item" />
  </div>
</template>
